module.exports = __webpack_public_path__ + "img/logo.383e63c0.png";